import { createReducer } from 'typesafe-actions'
import {
    removeEntireModelFilter,
    resetModelFiltersState,
    setModelFilter,
    setModelFiltersState,
} from '../actions/app/modelFilter.actions'

export type ModelFiltersState = {
    [id: string]: (string|number)[]
}

export const defaultState: ModelFiltersState = {}

const modelFiltersReducer = createReducer(defaultState)
    .handleAction(setModelFilter, (state, action) => {
        const { id, value, type } = action.payload
        const prevValues = state[id]
        const valueIsAlreadySet = prevValues !== undefined && prevValues.includes(value)

        if (valueIsAlreadySet) {
            return {
                ...state,
                [id]: prevValues.filter((prevValue) => prevValue !== value),
            }
        }

        const values = (prevValues === undefined || type === 'single' || type === 'max')
            ? [value]
            : [...prevValues, value]

        return {
            ...state,
            [id]: values,
        }
    })
    .handleAction(setModelFiltersState, (state, action) => ({ ...action.payload }))
    .handleAction(removeEntireModelFilter, (state, action) => {
        const filterId = action.payload

        return Object.fromEntries(
            Object.entries(state).filter(([key]) => key !== filterId),
        )
    })
    .handleAction(resetModelFiltersState, () => defaultState)

export default modelFiltersReducer
